"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var angular_1 = __importDefault(require("angular"));
var instructor_html_1 = __importDefault(require("./instructor.html"));
var instructor_controller_1 = __importDefault(require("./instructor.controller"));
var instructor_footer_nav_module_1 = __importDefault(require("./directives/footernav/instructor-footer-nav.module"));
var instructor_nav_module_1 = __importDefault(require("./directives/nav/instructor-nav.module"));
var batch_create_entity_module_1 = __importDefault(require("./directives/batch-create-entity/batch-create-entity.module"));
var complete_setup_module_1 = __importDefault(require("./directives/complete-setup/complete-setup.module"));
var instructor_dashboard_module_1 = __importDefault(require("./dashboard/instructor-dashboard.module"));
var instructor_documents_module_1 = __importDefault(require("./documents/instructor-documents.module"));
var Policies_1 = require("../classes/Policies");
var School_1 = require("../classes/School");
var Cashier_1 = require("../classes/Cashier");
var Order_1 = require("../classes/Order");
var ThirdPartyLibraries_1 = require("../../DriveScout/Billing/ThirdPartyLibraries");
function getCurrentUser(AuthService, UserService) {
    return AuthService.getCurrentUser()
        .then(function (response) {
        UserService.setCurrentUser(response);
        return UserService.getCurrentUser();
    })
        .catch(function (Error) {
        console.log(Error);
    });
}
getCurrentUser.$inject = ["AuthService", "UserService"];
function getPolicies(PoliciesModel, VueStoreFactory, CreateOrderService, ENV) {
    return PoliciesModel.getAll().then(function (response) {
        VueStoreFactory.dispatch("SET_POLICIES", response);
        var policies = (0, Policies_1.createFromPolicyAPIResponse)(response);
        var school = new School_1.School(__assign(__assign({}, response.school), { policies: policies.toArray() }));
        policies.setSchool(school);
        school.setPolicies(policies);
        var cashier = new Cashier_1.Cashier(school, new Order_1.Order());
        CreateOrderService.cashier(cashier);
        if (cashier.school().billingGatway().name().toLowerCase() === 'authorize') {
            (0, ThirdPartyLibraries_1.initAcceptJS)(ENV);
        }
        if (cashier.school().billingGatway().name().toLowerCase() === 'stripe') {
            (0, ThirdPartyLibraries_1.initStripe)(ENV);
        }
        VueStoreFactory.dispatch("SET_SCHOOL", __assign(__assign({}, response.school), { policies: policies.toArray() }));
        return {
            policies: policies,
            school: response.school,
        };
    });
}
getPolicies.$inject = [
    "PoliciesModel",
    "VueStoreFactory",
    "CreateOrderService",
    "ENV",
];
function config($stateProvider, $urlRouterProvider, USER_ROLES) {
    $stateProvider.state("drivecoach.instructor", {
        url: "/instructor",
        controller: "InstructorController",
        controllerAs: "vm",
        template: instructor_html_1.default,
        resolve: {
            currentUser: getCurrentUser,
            policies: getPolicies,
        },
        data: {
            authorizedRoles: [
                USER_ROLES.admin,
                USER_ROLES.owner,
                USER_ROLES.instructor,
            ],
        },
    });
}
config.$inject = ["$stateProvider", "$urlRouterProvider", "USER_ROLES"];
exports.default = angular_1.default
    .module("instructor", [
    instructor_nav_module_1.default.name,
    instructor_footer_nav_module_1.default.name,
    instructor_dashboard_module_1.default.name,
    instructor_documents_module_1.default.name,
    batch_create_entity_module_1.default.name,
    complete_setup_module_1.default.name,
])
    .config(config)
    .controller("InstructorController", instructor_controller_1.default);
